module.exports = __webpack_public_path__ + "img/logo.b2bb7a1f.png";